import {Message} from 'element-ui';
export default {
  formatSeconds(time) {
    var date = new Date(time)
    return date.getFullYear() + '-' + this.formatNumber(parseInt(date.getMonth()) + 1) + "-" + this.formatNumber(date.getDate()) + " " + this.formatNumber(date.getHours()) + ":" + this.formatNumber(date.getMinutes()) + ":" + this.formatNumber(date.getSeconds())
  },
  formatDate(time) {
    var date = new Date(time)
    return date.getFullYear() + '-' + this.formatNumber(parseInt(date.getMonth()) + 1) + "-" + this.formatNumber(date.getDate())
  },
  formatNumber(number) {
    if (number < 10) {
      return "0" + number
    } else return number
  },
  formatKeys(str) {
    var keys = Object.keys(str);
    var temp = ""
    for (var i = 0; i < keys.length; i++) {
      if(keys[i]=='from')
        temp = temp + keys[i] + '=' + str[keys[i]] + "&"
    }
    return temp
  },
  download(url) {
    const downloadLink = document.createElement('a');
    const body = document.documentElement || document.body;
    body.appendChild(downloadLink);
    downloadLink.href = url;
    downloadLink.click();
    body.removeChild(downloadLink);
  },
  message(message,type) {
    var message = message?message:"success"
    var type = type?type:"success"
    Message({
      message: message,
      type: type,
      duration: 1000,
    })
  }
}



// WEBPACK FOOTER //
// ./src/fetch/format.js